export default __webpack_public_path__ + "static/media/verifi.cef7f598.svg";